//If you want cookie consent
// import "./modules/cookie-consent";

//If you need a class to be toggled on a different element
// import "./modules/toggle";

//If you need to do something when its in/out of the viewport
// import "./modules/intersects";

document.getElementById("hamburger").addEventListener("click", function () {
  document.getElementById("mobile-menu").classList.toggle("active-menu");
  document.getElementById("hamburger").classList.toggle("is-active");
});

if (window.innerWidth > 1024) {
  var contentMargin = document.getElementById("header-child").offsetHeight;
} else {
  var contentMargin = document.getElementById(
    "header-child-mobile"
  ).offsetHeight;
}

document.getElementById("site-header").style.height = contentMargin + "px";
